// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"80f33c01","453":"8b4b26dc","462":"696fb746","481":"3f679330","923":"92ea6161"}[chunkId] + ".chunk.js";
};